export const CommonFractionDigits = 4;
export const MarketCapFractionDigits = 2;
